/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import {
  Box,
  darken,
  lighten,
  useTheme,
  IconButton,
  Tooltip,
} from '@mui/material';

import { ReactComponent as Delete } from 'src/assets/icons/trash.svg';

export default function RateiosTable({
  config,
  data,
  setSearch,
  setColuna,
  handleDelete,
}) {
  const menus = JSON.parse(localStorage.getItem('menus'));
  const headerColunas = 'Centro de Custo,Descrição'; //menus.rateios;

  const columns = useMemo(
    () => [
      {
        id: 'delete',
        header: ' ',
        enableEditing: false,
        grow: false,
        size: 50,
        minSize: 40,
        maxSize: 60,
        Cell: ({ row }) => (
          <Box className="deleteCell" sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip title="Deletar">
              <IconButton onClick={() => handleDelete(row)}>
                <Delete className="tableIcon line" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      {
        header: 'Cod. Centro de Custo',
        accessorKey: 'codccu',
        enableEditing: true,
      },
      {
        header: 'Descrição',
        accessorKey: 'desc',
        enableEditing: true,
      },
      {
        header: '% Rateio',
        accessorKey: 'valor',
        enableEditing: true,
        Cell: ({ cell }) => `${cell.getValue()}%`,
      },
      /*{
        header: 'Dif',
        accessorKey: 'dif',
      },*/
    ],
    [headerColunas]
  );

  const contasTable = useMaterialReactTable({
    columns,
    data,
    ...config,
  });

  return <MaterialReactTable table={contasTable} />;
}

RateiosTable.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  setSearch: PropTypes.func,
  setColuna: PropTypes.func,
};
